import { MenuItem, Stack, Typography } from '@mui/material'
import { PiPushPinBold, PiPushPinSlashBold } from 'react-icons/pi'
import { useUpdateTableTabColumnMutation } from '~/common/generated/apollo-operations'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'
import { DetailedTableTabColumn } from '~/components/tables/types'
import { DossColumnLevelMenuProps } from './DossColumnLevelMenu'

export function FreezeColumnMenuItem({
  isColumnFrozen,
  tableTabColumn,
  ...props
}: {
  isColumnFrozen: boolean
  tableTabColumn: DetailedTableTabColumn
} & Partial<DossColumnLevelMenuProps>) {
  const { t } = useTypedTranslation()
  const [updateTableTabColumn] = useUpdateTableTabColumnMutation({
    update(cache, { data }) {
      if (data?.updateTableTabColumn) {
        cache.modify({
          id: cache.identify(data.updateTableTabColumn),
          fields: {
            isFrozen() {
              return data.updateTableTabColumn.isFrozen
            },
          },
        })
      }
    },
  })

  return (
    <MenuItem
      onClick={async (e) => {
        props.hideMenu?.(e)
        await updateTableTabColumn({
          variables: {
            input: {
              tableColumnFilterId: tableTabColumn.id,
              isFrozen: !isColumnFrozen,
            },
          },
        })
      }}
    >
      <Stack
        alignItems="center"
        direction="row"
        display="flex"
        justifyContent="flex-start"
        spacing={1}
      >
        {isColumnFrozen ? <PiPushPinSlashBold /> : <PiPushPinBold />}
        <Typography variant="caption">
          {isColumnFrozen
            ? t('table.freeze_column_menu_item.unfreeze_column')
            : t('table.freeze_column_menu_item.freeze_column')}
        </Typography>
      </Stack>
    </MenuItem>
  )
}
